import { render, staticRenderFns } from "./BranchesList.vue?vue&type=template&id=2e7cbee5&scoped=true&"
import script from "./BranchesList.vue?vue&type=script&lang=js&"
export * from "./BranchesList.vue?vue&type=script&lang=js&"
import style0 from "./BranchesList.vue?vue&type=style&index=0&id=2e7cbee5&lang=scss&scoped=true&"
import style1 from "./BranchesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7cbee5",
  null
  
)

export default component.exports